// eslint-disable-next-line
import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const PrivateRoute = ({
  component: Component,
  auth,
  componentProps,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      //If not authenticated, redirect back to login.
      auth.isAuthenticated === true ? (
        <Component {...props} {...componentProps} />
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

PrivateRoute.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(PrivateRoute);
